import './App.css';
import React from 'react'
import { initializeApp } from "firebase/app";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';


import GIOMADODONINI from './G.madonini'
const firebaseConfig = {
  apiKey: "AIzaSyArr0fdzOREC-_EjQKAQvs4bRZOavt0Opc",
  authDomain: "opensea-796ad.firebaseapp.com",
  projectId: "opensea-796ad",
  storageBucket: "opensea-796ad.appspot.com",
  messagingSenderId: "191607956271",
  appId: "1:191607956271:web:a5c982bc4018fa434877da"
};




 function App() {
  const app = initializeApp(firebaseConfig);

  
return(
<Router>
      <div className="App-header">
       <Switch> 
       <Route  path="/G_madonini">
        <GIOMADODONINI />
       </Route>
       </Switch>
      </div>
    </Router>
)
}

export default App;
